import { render } from "./Storage_return_button.vue?vue&type=template&id=22c73fc4&scoped=true"
import script from "./Storage_return_button.vue?vue&type=script&lang=js"
export * from "./Storage_return_button.vue?vue&type=script&lang=js"

import "./Storage_return_button.vue?vue&type=style&index=0&id=22c73fc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c73fc4"]])

export default __exports__